import { Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

interface BannerStyleProps {
  flexibleBanner: boolean;
}

const BannerStyles = makeStyles<BannerStyleProps>()((theme: Theme, props) => ({
  fixedHeightWrapper: {
    height: '100px',
    [theme.breakpoints.up('md')]: {
      height: '140px',
    },
    [theme.breakpoints.up('lg')]: {
      height: '200px',
    },
  },
  media: {
    visibility: 'visible',
    width: '100%',
    height: props.flexibleBanner ? '' : '100%',
    objectFit: props.flexibleBanner ? 'contain' : 'cover',
  },
  hidden: {
    visibility: 'hidden',
    height: 0,
  },
}));

export default BannerStyles;
